import { endpoint } from 'services/endpoint';
import { http, httpPay, httpQ4US } from 'services/http';
import {
	TInvoiceListRequest,
	TDownloadInvoicePdfRequest,
	TDownloadInvoiceUdrCsvRequest,
	TUpdateInvoicePaymentBody,
	TUpdateInvoicePaymentResponse,
	TUpdateInvoiceCommentBody,
	TUpdateInvoiceCommentResponse,
	TSendEmailForInvoiceBody,
	TSendEmailForInvoiceResponse,
	TUpdateInvoiceGpsrBody,
	TUpdateInvoiceGpsrResponse,
	TEncryptInvoiceNumberRequest,
	TEncryptInvoiceNumberResponse,
	TNullifyInvoiceBody,
	TNullifyInvoiceResponse,
	TRemoveInvoiceLpfBody,
	TRemoveInvoiceLpfResponse,
	TInvoiceListExcelExportRequest,
	TInvoiceListExcelExportResponse,
	TDownloadInvoiceArchiveRequest,
	TCreditNoteListResponse,
	TCreditNoteSearchRequest,
} from 'redux/reducers/invoiceManagement/types';
import { TInvoiceManagementApi } from './types';

export const invoiceManagement: TInvoiceManagementApi = {
	getInvoiceList: (payload: TInvoiceListRequest) =>
		httpQ4US
			.post(endpoint.invoiceManagement.GET_INVOICE_LIST, payload)
			.then((response) => response.data),
	downloadInvoicePdf: (payload: TDownloadInvoicePdfRequest) =>
		httpQ4US
			.get(endpoint.invoiceManagement.DOWNLOAD_INVOICE_PDF(payload.emId, payload.invoiceId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	downloadInvoiceUdrCsv: (payload: TDownloadInvoiceUdrCsvRequest) =>
		http
			.get(endpoint.invoiceManagement.DOWNLOAD_INVOICE_UDR_CSV(payload.emId, payload.invoiceId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	updateInvoicePayment: (payload: TUpdateInvoicePaymentBody) =>
		httpQ4US
			.post(endpoint.invoiceManagement.UPDATE_INVOICE_PAYMENT, payload)
			.then((response) => response.data as TUpdateInvoicePaymentResponse),
	updateInvoiceComment: (payload: TUpdateInvoiceCommentBody) =>
		httpQ4US
			.post(endpoint.invoiceManagement.UPDATE_INVOICE_COMMENT, payload)
			.then((response) => response.data as TUpdateInvoiceCommentResponse),
	sendEmailForInvoice: (invoiceId: number, payload: TSendEmailForInvoiceBody) =>
		httpQ4US
			.post(endpoint.invoiceManagement.SEND_EMAIL_FOR_INVOICE(invoiceId), payload)
			.then((response) => response.data as TSendEmailForInvoiceResponse),
	updateInvoiceGpsr: (payload: TUpdateInvoiceGpsrBody) =>
		httpQ4US
			.post(endpoint.invoiceManagement.UPDATE_INVOICE_GPSR, payload)
			.then((response) => response.data as TUpdateInvoiceGpsrResponse),
	encryptInvoiceNumber: (payload: TEncryptInvoiceNumberRequest) =>
		httpPay
			.get(endpoint.payMaintenance.ENCRYPT_INVOICE_NUMBER, {
				params: { invoiceNumber: payload.invoiceNumber },
			})
			.then((response) => response.data as TEncryptInvoiceNumberResponse),
	nullifyInvoice: (payload: TNullifyInvoiceBody) =>
		http
			.put(endpoint.invoiceManagement.NULLIFY_INVOICE, payload)
			.then((response) => response.data as TNullifyInvoiceResponse),
	removeInvoiceLpf: (payload: TRemoveInvoiceLpfBody) =>
		http
			.put(endpoint.invoiceManagement.REMOVE_LPF, payload)
			.then((response) => response.data as TRemoveInvoiceLpfResponse),
	invoiceListExcelExport: (payload: TInvoiceListExcelExportRequest) =>
		httpQ4US
			.post(
				endpoint.invoiceManagement.INVOICE_LIST_EXCEL_EXPORT,
				{
					table_name: payload.tableName,
					filter: payload.filter,
				},
				{
					responseType: 'blob',
				},
			)
			.then((response) => response.data as TInvoiceListExcelExportResponse),
	downloadInvoiceArchive: (payload: TDownloadInvoiceArchiveRequest) =>
		http
			.get(endpoint.invoiceManagement.DOWNLOAD_INVOICE_ARCHIVE, {
				params: { filename: payload.filename },
				responseType: 'blob',
			})
			.then((response) => response.data),
	searchCreditNotes: (payload: TCreditNoteSearchRequest) =>
		http
			.post(endpoint.invoiceManagement.SEARCH_CREDIT_NOTES, payload)
			.then((response) => response.data as TCreditNoteListResponse),
};
